import { Panel } from "../../components/Panel";
import { Text } from "../../components/Text";
import Loader from "../../components/Loader";
import { Flex } from "components/Flex";
import { useTheme } from "styled-components";
import { IconType } from "react-icons/lib";

export type MiniWidgetProps = {
  title: string;
  text: string;
  icon: IconType;
  loading: boolean;
};

export const MiniWidget = ({
  title,
  text,
  icon: Icon,
  loading,
}: MiniWidgetProps) => {
  const theme = useTheme();

  return (
    <Panel p={2} height={70}>
      <Text
        fontSize={1}
        fontWeight={600}
        color={"grey3"}
        style={{ textTransform: "uppercase" }}
      >
        {title}
      </Text>
      {loading ? (
        <Loader tiny />
      ) : (
        <Flex alignItems="center">
          <Icon
            fontSize="0.8em"
            color={theme.colors.primary}
            style={{ top: 2, position: "relative" }}
          />
          <Text fontSize={4} color="primary" ml={1}>
            {text}
          </Text>
        </Flex>
      )}
    </Panel>
  );
};
